import { all } from 'redux-saga/effects';

import ErrorHandler from 'helpers/ErrorsHelpers';

import { watchRefreshAccessToken } from '../../commons/reduxModules/Authentication';
import { watchAddNotification } from '../../sagas/notificationsSaga';
import { watch as watchGtmSaga } from '../../commons/sagas/gtmSaga';
import { watch as watchMatomoSaga } from '../../commons/sagas/matomoSaga';

import { watch as watchInitApp } from './initAppSaga';
import { watch as watchOpenModal } from './openModalSaga';
import { watch as watchCloseModal } from './closeModalSaga';
import { watch as watchLocationChangeSaga } from './watchLocationChangeSaga';
import { watch as watchSendMessageToSupport } from './sendMessageToSupport';
import { watch as watchSendMessageToSalesman } from './sendMessageToSalesman';

// CMP
import CmpRootSaga from '../../consentManagementPlatform/sagas/index';

const errorHandler = new ErrorHandler();

function* rootSaga() {
    try {
        yield all([
            // Global
            watchRefreshAccessToken(),
            watchAddNotification(),
            watchGtmSaga(),
            watchMatomoSaga(),
            // App
            CmpRootSaga(),
            watchInitApp(),
            watchOpenModal(),
            watchLocationChangeSaga(),
            watchSendMessageToSupport(),
            watchSendMessageToSalesman(),
            watchCloseModal(),
        ]);
    } catch (e) {
        errorHandler.handleError(e);
    }
}

export default rootSaga;
